
  import {
    defineComponent,
    ref,
    onMounted,
    computed,
    onBeforeUnmount,
  } from 'vue';
  import { useRouter } from 'vue-router';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import Datatable from '@/components/kt-datatable/KTDatatable.vue';
  import Factors from '@/store/enums/IVELandFactorsEnums';

  export default defineComponent({
    name: 'sabah-city-options-listing',
    components: {
      Datatable,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const { can } = useAbility();

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('sabahCityFactorOptions'), [
          translate('ive'),
        ]);
      });

      onBeforeUnmount(() => {
        store.dispatch(Actions.RESET_IVE_FACTOR_OPTIONS_STORE);
      });

      await store.dispatch(
        Actions.GET_IVE_FACTOR_OPTIONS,
        Factors.SABAH_SEA_SPECS
      );
      const loading = ref(false);
      const tableHeader = ref([
        {
          name: translate('idColumn'),
          key: 'id',
          sortable: true,
        },
        {
          name: translate('sabahSeaSpecsNameEn'),
          key: 'titleEn',
          sortable: true,
        },
        {
          name: translate('sabahSeaSpecsNameAr'),
          key: 'titleAr',
          sortable: true,
        },
        {
          name: translate('status'),
          key: 'isActive',
          sortable: true,
        },
        {
          name: translate('actions'),
          key: 'actions',
        },
      ]);
      const toggleStatusSabah = async (Sabah) => {
        const deletedMessage = Sabah.isActive
          ? 'confirmInActive'
          : 'confirmActive';
        const result = await Swal.fire({
          title: translate('areYouSureQ'),
          icon: 'warning',
          text: translate(deletedMessage),
          showCancelButton: true,
          buttonsStyling: false,
          confirmButtonText: translate('confirm'),
          cancelButtonText: translate('cancel'),
          customClass: {
            confirmButton: 'btn fw-bold btn-warning',
            cancelButton: 'btn btn-light',
          },
        });

        if (result.value) {
          loading.value = true;
          await store.dispatch(Actions.DELETE_IVE_FACTOR_OPTION, Sabah.id);
          await store.dispatch(
            Actions.GET_IVE_FACTOR_OPTIONS,
            Factors.SABAH_SEA_SPECS
          );
          loading.value = false;
          const [errorName] = Object.keys(store.getters.getErrors);
          const error = store.getters.getErrors[errorName];
          if (error) {
            Swal.fire({
              text: translate(error[0]),
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: translate('tryAgainExcl'),
              customClass: {
                confirmButton: 'btn fw-bold btn-light-danger',
              },
            });
          } else {
            const successMsg = Sabah.isActive
              ? 'SUCCESSFULLY_INACTIVATED'
              : 'SUCCESSFULLY_ACTIVEATED';
            Swal.fire({
              text: translate(successMsg),
              icon: 'success',
              buttonsStyling: false,
              confirmButtonText: translate('ok'),
              customClass: {
                confirmButton: 'btn btn-light-primary',
              },
            });
          }
        }
      };

      const editSabah = (id) => {
        router.push({ name: 'sabah-city-options-editing', params: { id } });
      };

      const goTo = (pageName) => {
        router.push({ name: pageName });
      };

      const pageChanged = async (val) => {
        loading.value = true;
        await store.dispatch(
          Actions.UPDATE_IVE_FACTOR_OPTION_CURRENT_PAGE,
          val
        );
        await store.dispatch(
          Actions.GET_IVE_FACTOR_OPTIONS,
          Factors.SABAH_SEA_SPECS
        );
        loading.value = false;
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        tableData: computed(() => store.getters.factorOptionsList),
        tableHeader,
        toggleStatusSabah,
        translate,
        totalItems: computed(() => store.getters.factorOptionsListCount),
        pageChanged,
        goTo,
        editSabah,
        loading,
        can,
      };
    },
  });
